export enum EPricingStatus {
    BLOCKED = 'blocked',
    INCLUDED = 'included',
    EXTRA = 'extra',
}

export const pricingStatusAsString = (pricingStatus: EPricingStatus | string): string => {
    switch (pricingStatus) {
        case EPricingStatus.BLOCKED:
            return "Bloqué";
        case EPricingStatus.INCLUDED:
            return "Inclus";
        case EPricingStatus.EXTRA:
            return "Hors forfait";
        default:
            return pricingStatus.toString();
    }
};